package stocking;
import pixi.core.display.Container;
import pixi.extras.BitmapText;


class ColoredBitmapText extends Container
{

	public function new( text : String, style:BitmapTextStyle )
	{
		super();
		// NO MULTILINE SUPPORT.
		// OK! this is a dumb thing but here we go. General idea: Split the string
		// by ^c markers, cut out the escapes, make a bunch of little text elements
		// and stitch them together into one container.

		// What could pawsibly go wrong?
		var stringBits = text.split("^c");
		var tint = (style.tint != null ) ? style.tint : 0xffffff;
		var cursor = 0.;
		for(i in 0 ... stringBits.length )
		{
			var string = stringBits[i];
			// Ignore first chunk as it won't include a color code
			if( i > 0 )
			{
				var tintString = string.substr(0,6);
				string = string.substr(6);
				tint = Std.parseInt("0x" + tintString);
			}
			//trace('"$string"');
			// @todo hack ??
			string += " ";
			style.tint = tint;
			var bitmapText = new BitmapText(string, style);
			addChild(bitmapText);
			bitmapText.x = cursor;
			cursor += bitmapText.textWidth;
		}

		
	}
}